import { css } from '@emotion/css';
import { Mail, MapPin, Instagram, Linkedin } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';
import { ContactForm } from '../../shared/components/contact-form';
import Navbar from '../../shared/components/navbar/navbar';
import Footer from '../../shared/components/footer/footer';

const pageWrapper = css({
  minHeight: '100vh',
  background: 'var(--g-100)',
  display: 'flex',
  flexDirection: 'column',
});

const page = css({
  width: '100%',
  maxWidth: '1200px',
  margin: '0 auto',
  padding: 'var(--spacing-lg)',
  backgroundColor: 'var(--primary-color)',
  flex: 1,
});

const container = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'var(--spacing-lg)',
  width: '100%',
  margin: '0 auto',
});

const header = css({
  marginBottom: 'var(--spacing-lg)',
  borderBottom: '2px solid var(--pc-200)',
  paddingBottom: 'var(--spacing-md)',
  textAlign: 'left',
});

const title = css({
  fontSize: 'var(--fs-800)',
  fontWeight: 700,
  color: 'var(--pc-700)',
  marginBottom: 'var(--spacing-xs)',
  '@media (max-width: 768px)': {
    fontSize: 'var(--fs-700)',
  },
  '@media (max-width: 480px)': {
    fontSize: 'var(--fs-600)',
  },
});

const subtitle = css({
  fontSize: 'var(--fs-500)',
  color: 'var(--g-700)',
  fontWeight: 400,
  '@media (max-width: 768px)': {
    fontSize: 'var(--fs-450)',
  },
  '@media (max-width: 480px)': {
    fontSize: 'var(--fs-400)',
  },
});

const content = css({
  fontSize: 'var(--fs-400)',
  lineHeight: 1.6,
  color: 'var(--g-800)',
  '@media (max-width: 480px)': {
    fontSize: 'var(--fs-350)',
  },
});

const section = css({
  marginBottom: 'var(--spacing-lg)',
});

const sectionTitle = css({
  fontSize: 'var(--fs-600)',
  fontWeight: 600,
  color: 'var(--pc-600)',
  marginBottom: 'var(--spacing-sm)',
  paddingBottom: 'var(--spacing-xs)',
  borderBottom: '1px solid var(--pc-100)',
});

const info = css({
  marginTop: 'var(--spacing-lg)',
  display: 'flex',
  flexDirection: 'column',
  gap: 'var(--spacing-md)',
});

const infoItem = css({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 'var(--spacing-md)',
});

const infoIcon = css({
  color: 'var(--pc-500)',
  fontSize: 'var(--fs-600)',
  minWidth: '24px',
  flexShrink: 0,
});

const infoText = css({
  fontSize: 'var(--fs-400)',
  lineHeight: 1.6,
  '& strong': {
    color: 'var(--pc-600)',
    fontWeight: 600,
  },
});

const social = css({
  marginTop: 'var(--spacing-lg)',
  display: 'flex',
  gap: 'var(--spacing-md)',
  justifyContent: 'flex-start',
});

const socialIcon = css({
  fontSize: 'var(--fs-600)',
  color: 'var(--pc-500)',
  cursor: 'pointer',
  transition: 'color 0.2s',
  '&:hover': {
    color: 'var(--pc-700)',
  },
});

export function Contact() {
  return (
    <>
      <Navbar />
      <div className={pageWrapper}>
        <div className={page}>
          <div className={container}>
            <div className={header}>
              <h1 className={title}>Entre em Contato</h1>
              <p className={subtitle}>Estamos aqui para ajudar! Envie-nos sua mensagem.</p>
            </div>

        <div className={content}>
          <div className={section}>
            <h3 className={sectionTitle}>Formulário de Contato</h3>
            <ContactForm />
          </div>

          <div className={section}>
            <h3 className={sectionTitle}>Informações de Contato</h3>
            <div className={info}>
              <div className={infoItem}>
                <Mail className={infoIcon} />
                <div className={infoText}>
                  <p>
                    <strong>Email</strong>
                  </p>
                  <p>ajuda@anchoringressos.com.br</p>
                </div>
              </div>

              <div className={infoItem}>
                <FaWhatsapp className={infoIcon} />
                <div className={infoText}>
                  <p>
                    <strong>WhatsApp</strong>
                  </p>
                  <p>+55 11 94704-3137</p>
                </div>
              </div>

              <div className={infoItem}>
                <MapPin className={infoIcon} />
                <div className={infoText}>
                  <p>
                    <strong>Endereço</strong>
                  </p>
                  <p>São Paulo, SP - Brasil</p>
                </div>
              </div>
            </div>
          </div>

          <div className={section}>
            <h3 className={sectionTitle}>Redes Sociais</h3>
            <div className={social}>
              <Instagram
                className={socialIcon}
                onClick={() => window.open('https://www.instagram.com/anchorexperiences')}
                size={24}
              />
              <FaWhatsapp
                className={socialIcon}
                onClick={() =>
                  window.open(
                    'https://wa.me/send?l=pt&phone=5511947043137&text=%22Olá,%20quero%20conhecer%20a%20Anchor%20Experiences!%20Podem%20me%20ajudar?%22'
                  )
                }
              />
              <Linkedin
                className={socialIcon}
                onClick={() =>
                  window.open('https://www.linkedin.com/company/anchorexperiences/posts/?feedView=all')
                }
                size={24}
              />
            </div>
          </div>
        </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Contact;
